import React, { useState, useEffect } from 'react'
import { Select, Form, Input, Button, Cascader, Row, DatePicker, message } from "antd";
const { TextArea } = Input
const { RangePicker } = DatePicker;
import RoleApi from '@api/role'
import stationApi from '@api/station'
import moment from 'moment'
import AddModal from '@components/Modal'
import InspectionApi from '@api/inspectionnew'
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
export default ({ title, visible, formData = null, cancel, stationData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState()
  const [deviceLs, setDeviceLs] = useState([])
  const [roleLs, setRoleLs] = useState()  // 角色列表
  const [defectslevelLs, setDefectslevelLs] = useState([])  // 缺陷等级列表
  const [patrolDepts, setPatrolDepts] = useState([]);

  useEffect(() => {
    getPatrolDepts()
    // 角色
    RoleApi.query({ pageNum: 1, pageSize: 10000 }).then(res => {
      if (res.status !== '0') return
      setRoleLs(res.data.data)
    })
    // 缺陷等级列表
    InspectionApi.defectLevelLs({ pageNum: 1, pageSize: 10 }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setDefectslevelLs(res.data)
      }
    })
  }, [])

  const getPatrolDepts = () => {
      InspectionApi.getPatrolDeptsApi({}).then((res) => {
        setPatrolDepts(res.data);
      });
    };

  // 切换厂站查询设备
  const changStation = (e) => {
    stationApi.getDeviceByStationId({ stationId: e }).then(res => {
      if (res.status !== '0') return
      setDeviceLs(res.data)
    })
  }

  // 提交
  const submit = () => {
    setLoading(true)
    form.validateFields().then(values => {
      values.deviceRelevancyId = values.deviceRelevancyId[values.deviceRelevancyId.length - 1]
      values.beginTime = moment(values.beginTime).format('YYYY-MM-DD HH') + ':00:00'
      let param = {
        ...values,
        period: 0    // 周期
      }
      InspectionApi.taskAdd(param, { headers: { deptPath: values.deptPath } }).then(res => {
        if (res.status == 0) {
          message.success('新建成功')
          handelCancel()
        }
        setLoading(false)
      }).catch((err) => {
        setLoading(false)
      })
    })
  }
  // 取消
  const handelCancel = () => {
    form.resetFields();
    cancel(false);
  }

  return (
    <AddModal title={title} footer={[
      <Row key={'btn'} span={24}>
        <Button key={1} onClick={handelCancel} className='abuttons'>
          <i className='iconfont iconfanhui'>
          </i>&nbsp;&nbsp;取消
        </Button>
        <Button key={2} loading={loading} onClick={submit} className='abuttons' type="primary">
          <i className='iconfont iconbaocun'>
          </i>&nbsp;&nbsp;保存
        </Button>
      </Row>]
    } visible={visible} okText={'确定'} onCancel={handelCancel} onSubmit={() => submit()}>
      <Form
        {...layout}
        layout="horizontal"
        form={form}
        style={{ marginTop: '20px' }}
      >
        <Form.Item
          label='任务名称'
          name="name"
          rules={[{ required: true, message: '请输入任务名称' }]}
        >
          <Input placeholder={'请输入任务名称'} />
        </Form.Item>
        <Form.Item
          label='巡检厂站'
          name="stationId"
          rules={[{ required: true, message: '请选择巡检厂站!' }]}
        >
          <Select
            onChange={(e) => changStation(e)}
            placeholder="请选择">
            {
              stationData && stationData.map((item, idx) => {
                return (
                  <Select.Option value={item.value * 1} key={'stationId-' + idx}>{item.title || item.name}</Select.Option>
                )
              })
            }
          </Select>
        </Form.Item>
        <Form.Item label="巡检设备" name="deviceRelevancyId" rules={[{ required: true, message: '请选择巡检设备' }]}>
          <Cascader
            fieldNames={{
              label: 'itemName',
              value: 'id',
              children: 'child',
            }}
            options={deviceLs}
            placeholder="请选择设备"
          />
        </Form.Item>
        <Form.Item
          label='缺陷等级'
          name="defectLevelId"
          rules={[{ required: true, message: '请选择缺陷等级!' }]}
        >
          <Select
            placeholder="请选择缺陷等级">
            {
              defectslevelLs && defectslevelLs.map((item) => {
                return (
                  <Select.Option value={item.id} key={item.id}>{item.defectLevelName}</Select.Option>
                )
              })
            }
          </Select>
        </Form.Item>
        <Form.Item
          label='巡检角色'
          name="handleRoleId"
          rules={[{ required: true, message: '请选择巡检角色!' }]}
        >
          <Select placeholder="请选择">
            {
              roleLs && roleLs.length && roleLs.map(item => {
                return <Select.Option value={item.id - 0} key={item.id}>{item.name}</Select.Option>
              })
            }
          </Select>
        </Form.Item>
        <Form.Item
            label="巡检班组"
            name="handleDeptId"
            rules={[{ required: true, message: "请选择巡检班组!" }]}
          >
            <Select placeholder="请选择巡检班组">
              {patrolDepts.map((item) => (
                <Select.Option value={item.id - 0} key={item.id}>
                  {item.deptName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        <Form.Item
          label='开始时间'
          name='beginTime'
          rules={[{ required: true, message: '请选择时间' }]}
        >
          <DatePicker showTime format="YYYY-MM-DD HH" />
        </Form.Item>
        <Form.Item
          label='巡检内容'
          name="itemContent"
          rules={[{ required: true, message: '请输入巡检内容' }]}
        >
          <TextArea rows={4} placeholder="请输入巡检内容" />
        </Form.Item>
      </Form>
    </AddModal>
  )

}
